<template>
  <div>
    <div class="flex items-center" v-if="deliveryType != ''">
      <p v-if="deliveryType == 'delivery'" class="text-md lg:text-2xl mr-2">
        Escribe <span v-if="giftOrder">la dirección destino</span><span v-else>tu dirección</span> para encontrar la tienda que entregará tu pedido.
      </p>
      <p v-else class="text-lg lg:text-3xl">
        Selecciona la tienda a donde pasarás a recoger tu pedido <span v-if="giftOrder">para regalo</span>.
      </p>
      <vs-button v-if="deliveryType == 'delivery'" class="mt-2 ml-1" @click="setCarryOut()">Prefiero pasar a recogerlo</vs-button>
      <vs-button v-else class="mt-2 ml-1" @click="$store.dispatch('updateDeliveryType', 'delivery');">Prefiero envío a domicilio</vs-button>
      <vs-button v-if="giftOrder" class="mt-2 ml-1" @click="cancelGiftOrder()">Cancelar orden para regalo</vs-button>
    </div>
    <div class="vx-row m-2 order-last lg:order-first">
      <div class="vx-col w-full lg:w-3/5">
        <MapboxMap ref="map" class="flex w-full" :center="center" :zoom="zoom" :stores="markers" @dragend="dragEnd"/>
      </div>
      <div v-if="deliveryType == 'delivery'" class="vx-col w-full lg:w-2/5 order-first lg:order-last">
        <vx-card>
          <span class="text-xs mt-2 ml-1 opacity-75">Selecciona departamento</span>
          <v-select :options="states" label="name" clearable clearSearchOnSelect class="mb-2" placeholder="Seleciona un departamento" v-model="selectedState">
            <div slot="no-options">No se encontraron departamentos</div>
          </v-select>
          <span class="text-xs mt-2 ml-1 opacity-75">Selecciona municipio</span>
          <v-select :options="cities" label="name" clearable clearSearchOnSelect class="mb-2" placeholder="Seleciona un municipio" v-model="selectedCity">
            <div slot="no-options">No se encontraron municipios</div>
          </v-select>
          <div class="flex flex-col relative w-full mb-2">
            <span class="text-xs mt-2 ml-1 opacity-75">Escribe tu dirección completa y luego ubícala en el mapa</span>
            <vs-input class="w-full" placeholder="Dirección completa" v-model="address" @input="changeAddress" @keyup.enter="validateAddress"/>
            <!-- SEARCH ICON -->
            <div class="absolute top-0 right-0 py-8 px-2 z-50">
              <feather-icon icon="SearchIcon" svgClasses="h-6 w-6 cursor-pointer" @click="validateAddress"/>
            </div>
            <!-- SEARCH ICON -->
            <div class="absolute top-0 right-0 py-8 px-10">
              <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer" @click="address = ''"/>
            </div>

            <span v-if="addresses.length > 0" class="text-xs mt-2 ml-1 opacity-75">Coloca el marcador naranja en la ubicación exacta de entrega</span>
          </div>
          <div v-if="foundStore != null" class="flex flex-col w-full mb-2">
            <span class="text-xs mt-2 ml-1 opacity-75">Tienda que enviará el pedido</span>
            <span class="text-2xl mt-2 ml-1">{{ foundStore.name }}</span>
            <vs-button class="mt-2 ml-1" v-if="checkDelivery(foundStore)" @click="setSelectedStore(foundStore, 'delivery')">Seleccionar tienda</vs-button>
          </div>
        </vx-card>
      </div>
      <div v-else class="vx-col w-full lg:w-2/5 order-2 lg:order-last">
        <vx-card>
          <vs-input class="w-full mb-2" icon="search" icon-after="true" placeholder="Buscar..." :value="storeSearch" @input="refineStores($event)" @keyup.esc="refineStores('')"/>
          <!--          <v-select :options="states" label="name" clearable clearSearchOnSelect class="mb-2" placeholder="Seleciona un departamento" v-model="selectedState">-->
          <!--            <div slot="no-options">No se encontraron departamentos</div>-->
          <!--          </v-select>-->
          <!--          <v-select :options="cities" label="name" clearable clearSearchOnSelect class="mb-2" placeholder="Seleciona un municipio" v-model="selectedCity">-->
          <!--            <div slot="no-options">No se encontraron municipios</div>-->
          <!--          </v-select>-->
          <div class="hidden md:flex">
            <vs-table notSpacer stripe maxHeight="300px" noDataText="No se encontratron tiendas" :data="storesFiltered()" v-model="selectedStoreTable" ref="table">
              <template slot="thead">
                <vs-th>Nombre</vs-th>
                <vs-th>Dirección</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>
                  <vs-td :data="data[indextr].stateName">
                    {{ data[indextr].address }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="hidden md:flex flex-col items-start mt-2 p-4" v-if="selectedStoreTable.name != ''">
            <div class="text-xl text-black">{{ selectedStoreTable.name }}</div>
            <div>{{ selectedStoreTable.address }}</div>
            <div>{{ selectedStoreTable.cityName }}, {{ selectedStoreTable.stateName }}</div>
            <div><b>Horario de atención en tienda:</b> {{ selectedStoreTable.carryTime }}</div>
            <div v-if="selectedStoreTable.delivery"><b>Horario de servicio a domicilio:</b> {{ selectedStoreTable.deliveryTime }}</div>
            <div v-else>Esta tienda no ofrece servicio a domicilio</div>
          </div>
          <div class="flex md:hidden">
            <vs-list>
              <vs-list-item
                v-for="item in storesFiltered()"
                :key="item.code"
                :title="item.name"
                :subtitle="`${item.address}`"
              >
                <vs-button size="small" radius icon="location_on" @click="setSelectedStoreTable(item)"></vs-button>
              </vs-list-item>
            </vs-list>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select';
import states from '@/store/data/states.json';
import cities from '@/store/data/cities.json';
import MapboxMap from './components/MapBoxMap';
import {point, polygon, booleanPointInPolygon} from '@turf/turf';
// import {gmapApi} from 'vue2-google-maps';
// import stores from '@/store/data/stores.json';
// import {db} from '@/firebaseConfig'

export default {
  components: {
    'v-select': vSelect,
    MapboxMap
  },
  data() {
    return {
      center: [-90.5131097, 14.6426439],
      zoom: 14,
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      //optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {width: 0, height: -35}
      },
      searches: 0,
      address: this.$store.state.deliveryAddress.address,
      storeSearch: '',
      selectedState: {"id": this.$store.state.deliveryAddress.stateId, "name": "Guatemala"},
      selectedCity: {"id": this.$store.state.deliveryAddress.cityId, "stateId": this.$store.state.deliveryAddress.stateId, "name": ""},
      selectedStore: null,
      foundStore: null,
      addressMarker: null,
      selectedStoreTable: {
        name: ''
      },
      markers: [],
      addresses: [],
      perimeter: []
    }
  },
  computed: {
    turfPoint() {
      return point;
    },
    turfPolygon() {
      return polygon;
    },
    turfBooleanPointInPolygon() {
      return booleanPointInPolygon;
    },
    states() {
      return states.states;
    },
    cities() {
      if (this.selectedState == null) {
        return [];
      } else {
        return cities.cities.filter(item => item.stateId == this.selectedState.id);
      }
    },
    searchAddress() {
      if (this.address.trim() == '' || this.selectedState == null || this.selectedCity == null) {
        return '';
      } else {
        return `${this.address.trim()}, ${this.selectedState.name.trim()}, ${this.selectedCity.name.trim()}`;
      }
    },
    stores() {
      return this.$store.getters.stores.filter(item => item.longitude != 0 && item.latitude != 0);
    },
    giftOrder() {
      return this.$store.state.giftOrder;
    },
    deliveryType() {
      return this.$store.state.deliveryType;
    },
    polygonOptions() {
      return {
        strokeColor: "#5ba8b2",
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: "#5ba8b2",
        fillOpacity: 0.10
      }
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    windowMD() {
      return (this.$store.state.windowWidth > 768);
    }
  },
  watch: {
    selectedState() {
      if (this.geocoder) {
        this.validateAddress();
      }
      this.$store.dispatch('updateDeliveryAddress', {stateId: this.selectedState.ids});
    },
    selectedCity() {
      if (this.geocoder) {
        this.validateAddress();
      }
      this.$store.dispatch('updateDeliveryAddress', {cityId: this.selectedCity.id});
    },
    selectedStoreTable: function () {
      const zoom = 14;
      this.$refs.map.flyTo({center: [this.selectedStoreTable.longitude, this.selectedStoreTable.latitude], zoom: zoom});
      this.zoom = zoom;
      const idx = this.markers.findIndex(marker => marker.code == this.selectedStoreTable.code);
      if (idx >= 0) {
        if (this.markers[idx].hasOwnProperty('perimeter')) {
          this.perimeter = this.markers[idx].perimeter;
        }
        this.$refs.map.togglePopUp(this.markers[idx]);
      }
      window.scrollTo(0, 0);
    }
  },
  methods: {
    getPosition(position) {
      this.center = [position.coords.longitude, position.coords.latitude];
    },
    getPaths() {
      let coords = [];
      let coord = [];
      for (var i = 0; i < this.perimeter.length; i++) {
        coord = this.perimeter[i].split(',');
        coords.push({lat: parseFloat(coord[1]), lng: parseFloat(coord[0])});
      }
      return coords;
    },
    loadStoreMarkers() {
      this.markers = [];
      let day = 0;
      let detailCarryHours = false;
      let carry1 = [];
      let carryOutHours = [];
      let carryTime = '';
      let detailDeliveryHours = false;
      let delivery1 = [];
      let deliveryTime = '';
      let deliveryHours = [];
      let days = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
      if (this.windowMD) {
        days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      }
      for (let i = 0; i < this.stores.length; i++) {
        detailCarryHours = this.stores[i].hasOwnProperty('carryOutHours');
        carryOutHours = [];
        if (detailCarryHours) {
          // carryOutHours = this.stores[i].carryOutHours;
          carry1 = [];
          carryOutHours = [];
          for (let j = 0; j < this.stores[i].carryOutHours.length; j++) {
            carry1.push({
              day: j,
              title: days[j],
              hours: this.windowMD ? `${this.stores[i].carryOutHours[j].open} a ${this.stores[i].carryOutHours[j].close}` : `${this.stores[i].carryOutHours[j].open}-${this.stores[i].carryOutHours[j].close}`
            });
          }
          if (carry1.length > 1) {
            carry1.push(carry1[0]);
            carry1[carry1.length-1].day = 7;
            carry1.splice(0, 1);
            carryOutHours.push({
              day: carry1[0].day,
              title: carry1[0].title,
              hours: carry1[0].hours
            });
            for (let k = 1; k < carry1.length; k++) {
              if (carry1[k].hours != carry1[k-1].hours) {
                carryOutHours.push({
                  day: carry1[k].day,
                  title: carry1[k].title,
                  hours: carry1[k].hours
                });
              }
            }
            carryOutHours.push({
              day: carry1[6].day,
              title: carry1[6].title,
              hours: carry1[6].hours
            });
            for (let l = 0; l < carryOutHours.length - 1; l++) {
              if ((carryOutHours[l+1].day - carryOutHours[l].day) > 1) {
                day = carryOutHours[l+1].day - 1;
                carryOutHours[l].title = this.windowMD ? `${carryOutHours[l].title} a ${days[day]}` : `${carryOutHours[l].title}-${days[day]}`;
              }
            }
            if (carryOutHours.length > 1) {
              if (carryOutHours[carryOutHours.length - 1].title == carryOutHours[carryOutHours.length - 2].title) {
                carryOutHours.pop();
              } else {
                if (carryOutHours[carryOutHours.length - 1].hours == carryOutHours[carryOutHours.length - 2].hours) {
                  day = carryOutHours[carryOutHours.length - 1].day == 7 ? 0 : carryOutHours[carryOutHours.length - 1].day;
                  carryOutHours[carryOutHours.length - 2].title = this.windowMD ? `${days[carryOutHours[carryOutHours.length - 2].day]} a ${days[day]}` : `${days[carryOutHours[carryOutHours.length - 2].day]}-${days[day]}`;
                  carryOutHours.pop();
                }
              }
            }
            carryTime = '';
            for (let l = 0; l < carryOutHours.length; l++) {
              carryTime += (carryTime == '' ? '' : ', ') + `${carryOutHours[l].title} de ${carryOutHours[l].hours}`;
            }
          }
        }
        detailDeliveryHours = this.stores[i].hasOwnProperty('deliveryHours');
        deliveryHours = [];
        if (detailDeliveryHours) {
          // deliveryHours = this.stores[i].deliveryHours;
          delivery1 = [];
          deliveryHours = [];
          for (let j = 0; j < this.stores[i].deliveryHours.length; j++) {
            delivery1.push({
              day: j,
              title: days[j],
              hours: this.windowMD ? `${this.stores[i].deliveryHours[j].open} a ${this.stores[i].deliveryHours[j].close}` : `${this.stores[i].deliveryHours[j].open}-${this.stores[i].deliveryHours[j].close}`
            });
          }
          if (delivery1.length > 1) {
            delivery1.push(delivery1[0]);
            delivery1[delivery1.length-1].day = 7;
            delivery1.splice(0, 1);
            deliveryHours.push({
              day: delivery1[0].day,
              title: delivery1[0].title,
              hours: delivery1[0].hours
            });
            for (let k = 1; k < delivery1.length; k++) {
              if (delivery1[k].hours != delivery1[k-1].hours) {
                deliveryHours.push({
                  day: delivery1[k].day,
                  title: delivery1[k].title,
                  hours: delivery1[k].hours
                });
              }
            }
            deliveryHours.push({
              day: delivery1[6].day,
              title: delivery1[6].title,
              hours: delivery1[6].hours
            });
            for (let l = 0; l < deliveryHours.length - 1; l++) {
              if ((deliveryHours[l+1].day - deliveryHours[l].day) > 1) {
                day = deliveryHours[l+1].day - 1;
                deliveryHours[l].title = this.windowMD ? `${deliveryHours[l].title} a ${days[day]}` : `${deliveryHours[l].title}-${days[day]}`;
              }
            }
            if (deliveryHours.length > 1) {
              if (deliveryHours[deliveryHours.length - 1].title == deliveryHours[deliveryHours.length - 2].title) {
                deliveryHours.pop();
              } else {
                if (deliveryHours[deliveryHours.length - 1].hours == deliveryHours[deliveryHours.length - 2].hours) {
                  day = deliveryHours[deliveryHours.length - 1].day == 7 ? 0 : deliveryHours[deliveryHours.length - 1].day;
                  deliveryHours[deliveryHours.length - 2].title = this.windowMD ? `${days[deliveryHours[deliveryHours.length - 2].day]} a ${days[day]}` : `${days[deliveryHours[deliveryHours.length - 2].day]}-${days[day]}`;
                  deliveryHours.pop();
                }
              }
            }
            deliveryTime = '';
            for (let l = 0; l < deliveryHours.length; l++) {
              deliveryTime += (deliveryTime == '' ? '' : ', ') + `${deliveryHours[l].title} de ${deliveryHours[l].hours}`;
            }
          }
        }
        // carryTime: `De lunes a domingo, de ${this.stores[i].carryOutOpenHour} a ${this.stores[i].carryOutCloseHour} horas`,
        // deliveryTime: `De lunes a domingo, de ${this.stores[i].deliveryOpenHour} a ${this.stores[i].deliveryCloseHour} horas`,
        // this.stores[i].carryTime = carryTime;
        // this.stores[i].deliveryTime = deliveryTime;
        this.markers.push({
          type: 'store',
          draggable: false,
          application: this.stores[i].application,
          code: this.stores[i].code,
          position: [this.stores[i].longitude, this.stores[i].latitude],
          stockId: this.stores[i].stockId,
          infoText: this.stores[i].name,
          name: this.stores[i].name,
          address: this.stores[i].address,
          cityName: this.stores[i].cityName,
          stateName: this.stores[i].stateName,
          delivery: this.stores[i].delivery,
          carryOut: this.stores[i].carryOut,
          ipAddress: this.stores[i].ipAddress,
          port: this.stores[i].port,
          priceList: this.stores[i].priceList,
          detailCarryHours: detailCarryHours,
          carryOutHours: carryOutHours,
          carryOutHoursArray: this.stores[i].carryOutHours,
          detailDeliveryHours: detailDeliveryHours,
          deliveryHours: deliveryHours,
          deliveryHoursArray: this.stores[i].deliveryHours,
          carryOutOpenHour: this.stores[i].carryOutOpenHour,
          carryOutCloseHour: this.stores[i].carryOutCloseHour,
          deliveryOpenHour: this.stores[i].deliveryOpenHour,
          deliveryCloseHour: this.stores[i].deliveryCloseHour,
          carryTime: carryTime,
          deliveryTime: deliveryTime,
          perimeter: this.stores[i].hasOwnProperty('perimeter') ? this.stores[i].perimeter : []
        });
      }
      // this.$refs.map.markStores(this.markers);
    },
    setCarryOut() {
      this.$store.dispatch('updateDeliveryType', 'carryOut');
    },
    cancelGiftOrder() {
      this.$store.dispatch('updateGiftOrder', false);
    },
    resolvePaths(perimeter) {
      let coords = [];
      let coord = [];
      for (var i = 0; i < perimeter.length; i++) {
        coord = perimeter[i].split(',');
        coords.push({lat: parseFloat(coord[1]), lng: parseFloat(coord[0])});
      }
      return coords;
    },
    changeAddress() {
      this.foundStore = null;
      this.$store.dispatch('updateSelectedStore', null);
    },
    polygonFromPerimeter(perimeter) {
      const polygon = [];
      for (let i = 0; i < perimeter.length; i++) {
        polygon.push([parseFloat(perimeter[i].split(',')[0]), parseFloat(perimeter[i].split(',')[1])])
      }
      return [polygon];
    },
    findStore(marker) {
      let store = null;
      for (let i = 0; i < this.stores.length; i++) {
        if (store == null) {
          if (this.stores[i].hasOwnProperty('perimeter')) {
            if (this.stores[i].perimeter.length > 0) {
              // console.log(this.stores[i].code, this.stores[i].name);
              // storePerimeter = new this.google.maps.Polygon({paths: this.resolvePaths(this.stores[i].perimeter)});
              const storePerimeter = this.turfPolygon(this.polygonFromPerimeter(this.stores[i].perimeter));
              const position = this.turfPoint(marker.position);
              if (this.turfBooleanPointInPolygon(position, storePerimeter)) {
                store = this.stores[i];
              }
            }
          }
        }
      }
      if (store == null) {
        this.$vs.notify({
          title: 'Dirección fuera de cobertura',
          text: `Lo sentimos, no encontramos una tienda con cobertura de despacho a ${this.address}`,
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        });
      } else if (this.checkDelivery(store)) {
        this.$store.dispatch('updateSelectedStore', store);
        const idx = this.markers.findIndex(marker => marker.code == store.code);
        if (idx >= 0) {
          if (this.markers[idx].hasOwnProperty('perimeter')) {
            this.perimeter = this.markers[idx].perimeter;
          }
          this.$refs.map.togglePopUp(this.markers[idx]);
        }
        window.scrollTo(0, 0);
      } else {
        this.$vs.notify({
          title: 'Tienda no puede despachar',
          text: `Lo sentimos, la tienda ${store.name} no puede despachar en este momento a ${this.address}`,
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        });
      }
      this.foundStore = store;
    },
    afterDrag(location) {
      this.center = location.latLng;
      this.$store.dispatch('updateDeliveryAddress', {lat: this.center.lat(), lng: this.center.lng()});
      let marker = this.addresses.find(item => item.type === 'address');
      if (marker) {
        marker.position = location.latLng;
        this.findStore(marker);
      }
    },
    dragEnd(args) {
      this.center = [args.marker.getLngLat().lng, args.marker.getLngLat().lat];
      this.$store.dispatch('updateDeliveryAddress', {lat: args.marker.getLngLat().lat, lng: args.marker.getLngLat().lng});
      let marker = this.markers.find(item => item.type === 'address');
      if (marker) {
        marker.position = this.center;
        this.findStore(marker);
      }
    },
    validateAddress() {
      this.searches += 1;
      const self = this;
      if (this.address == '') {
        if (this.searches > 1) {
          this.$vs.notify({
            title: 'Error al buscar dirección',
            text: 'Debes escribir una dirección',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          });
        }
      } else if (this.selectedState == null) {
        this.$vs.notify({
          title: 'Error al buscar dirección',
          text: 'Debes seleccionar un departamento',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        });
      } else if (this.selectedCity == null) {
        this.$vs.notify({
          title: 'Error al buscar dirección',
          text: 'Debes seleccionar un municipio',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        });
      } else {
        this.$store.dispatch('updateDeliveryAddress', {address: this.address});
        // this.fullAddress = `${this.address.trim()}, ${this.selectedState.name}, ${this.selectedCity.name}`;
        const address = {
          address_line_1: this.address.trim(),
          address_line_2: '',
          city: this.selectedCity.name,
          state: this.selectedState.name,
          country: 'Guatemala'
        }
        // this.$geocoder.send(address, function (results, status) {
        this.$geocoder.send(address, function (results) {
          if (results.status == 'OK') {
            self.center = [results.results[0].geometry.location.lng, results.results[0].geometry.location.lat];
            self.zoom = 17;
            self.$store.dispatch('updateDeliveryAddress', {lat: self.center[1], lng: self.center[0]});
            // var location = self.markers.filter(function(item) {return item.type == 'address'});
            let location = self.markers.find(item => item.type === 'address');
            if (location) {
              location.position = self.center;
              location.infoText = self.address;
              location.name = self.address;
              location.address = self.address;
            } else {
              const marker = {
                type: 'address',
                draggable: true,
                code: '',
                position: self.center,
                stockId: '',
                infoText: self.address,
                name: self.address,
                address: 'Por favor posiciona este marcador en la ubicación exacta de tu dirección',
                delivery: false,
                carryOut: true,
                ipAddress: '',
                port: '',
                carryOutOpenHour: '',
                carryOutCloseHour: '',
                deliveryOpenHour: '',
                deliveryCloseHour: '',
                carryTime: '',
                deliveryTime: '',
                perimeter: []
              };
              self.markers.push(marker);
              self.findStore(marker);
              setTimeout(() => {
                if (self.$refs.hasOwnProperty('map')) {
                  self.$refs.map.togglePopUp(marker);
                  self.$refs.map.flyTo({center: self.center});
                }
              }, 300);
              // const idx = self.markers.findIndex(marker => marker.type == 'address');
              // if (idx >= 0) {
              //   self.$refs.map.togglePopUp(self.markers[idx]);
              // }
              window.scrollTo(0, 0);
            }
          } else {
            self.$vs.notify({
              title: 'Error al buscar dirección',
              text: 'No fue posible ubicar la dirección en el mapa, corrige la dirección o intenta con otra',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            });
          }
        });
      }
    },
    refineStores(value) {
      this.storeSearch = value;
    },
    storesFiltered() {
      const self = this;
      let stores = [...this.stores].filter(item => (item.name.CIAI().indexOf(self.storeSearch.CIAI()) !== -1 || item.address.CIAI().indexOf(self.storeSearch.CIAI()) !== -1));
      if (this.deliveryType) {
        if (this.deliveryType == 'delivery') {
          stores = [...stores].filter((item => item.delivery));
        }
      }
      return stores;
    },
    storesFiltered1() {
      var self = this;
      var stores = [];
      if (this.selectedState == null) {
        if (this.selectedCity == null) {
          stores = [...new Set(this.stores)];
        } else {
          stores = [...new Set(this.stores.filter(function (item) {
            return item.cityId == self.selectedCity.id;
          }))];
        }
      } else {
        if (this.selectedCity == null) {
          stores = [...new Set(this.stores.filter(function (item) {
            return item.stateId == self.selectedState.id;
          }))];
        } else {
          stores = [...new Set(this.stores.filter(function (item) {
            return (item.cityId == self.selectedCity.id);
          }))];
        }
      }
      if (this.deliveryType) {
        if (this.deliveryType == 'delivery') {
          stores = [...new Set(this.stores.filter((item => item.delivery)))];
        }
      }
      return stores;
    },
    setSelectedStoreTable(store) {
      this.selectedStoreTable = store;
      window.scrollTo(0, 0);
    },
    setSelectedStore(store, deliveryType) {
      this.$store.dispatch('updateDeliveryType', deliveryType);
      this.$store.dispatch('updateSelectedStore', store);
      this.$store.dispatch('updateHomeScreen', 2);
      this.$router.push({name: 'shop'});
    },
    checkCarry(store) {
      var ret = false;
      if (store.carryOut) {
        const now = new Date();
        const dow = now.getDay();
        // const open = parseInt(store.carryOutOpenHour.split(':')[0]);
        // const close = parseInt(store.carryOutCloseHour.split(':')[0]);
        // const closeHour = parseInt(store.carryOutCloseHour.split(':')[1]);
        const open = parseInt(store.carryOutHours[dow].open.split(':')[0]);
        const close = parseInt(store.carryOutHours[dow].close.split(':')[0]);
        const closeHour = parseInt(store.carryOutHours[dow].close.split(':')[1]);
        if (now.getHours() >= open) {
          if (now.getHours() < close) {
            ret = true;
          } else if (now.getHours() == close && now.getMinutes() < closeHour) {
            ret = true;
          }
        }
      }
      return ret;
    },
    checkDelivery(store) {
      var ret = false;
      if (store.delivery) {
        const now = new Date();
        const dow = now.getDay();
        // const open = parseInt(store.deliveryOpenHour.split(':')[0]);
        // const close = parseInt(store.deliveryCloseHour.split(':')[0]);
        // const closeHour = parseInt(store.deliveryCloseHour.split(':')[1]);
        const open = parseInt(store.deliveryHours[dow].open.split(':')[0]);
        const close = parseInt(store.deliveryHours[dow].close.split(':')[0]);
        const closeHour = parseInt(store.deliveryHours[dow].close.split(':')[1]);
        if (now.getHours() >= open) {
          if (now.getHours() < close) {
            ret = true;
          } else if (now.getHours() == close && now.getMinutes() < closeHour) {
            ret = true;
          }
        }
      }
      return ret;
    }
  },
  mounted() {
    this.$geocoder.setDefaultCountryCode('GT');
    this.$geocoder.setDefaultLanguage('es');
    if (!this.$store.state.deliveryType) {
      this.$store.dispatch('updateDeliveryType', 'delivery');
    }
    if (navigator.geolocation) {
      if (this.address == '') {
        navigator.geolocation.getCurrentPosition(this.getPosition);
      }
    }
    if (this.stores) {
      this.loadStoreMarkers();
    }
    const state = this.states.filter((stateId) => stateId.id === this.$store.state.deliveryAddress.stateId);
    if (state.length > 0) {
      this.selectedState = state[0];
      const city = cities.cities.filter((cityId) => cityId.id === this.$store.state.deliveryAddress.cityId);
      if (city.length > 0) {
        this.selectedCity = city[0];
      }
    }
    if (this.address != '') {
      this.validateAddress(true);
    }
    this.zoom = this.windowMD ? 14 : 13;
  }
}
</script>
